if (!customElements.get('modal-custom-size')) {
  customElements.define(
    'modal-custom-size',
    class modalCustomSize extends HTMLElement {
      constructor() {
        super();

        this._isValid = false;
        this.customSize = null;

        this.maxBothCompare = 48;

        this.shipperMinSizes = {
          length: 3,
          width: 3,
          height: 3,
        };

        this.bothCompare = ['length', 'width'];

        this.shipperMaxSizes = {
          length: 31,
          width: 31,
          height: 31,
        };

        this.mailerMinSizes = {
          length: 3,
          width: 2,
          height: 1,
        };

        this.mailerMaxSizes = {
          length: 24,
          width: 24,
          height: 8,
        };

        this.boxType = null;
        if (this.dataset && this.dataset.boxtype) {
          this.boxType = this.dataset.boxtype;
        }

        this.errorContainer = this.querySelector('.message-error');

        this.closeModal = this.querySelector('.close-modal');
        if (this.closeModal) {
          this.closeModal.addEventListener('click', (e) => {
            e.preventDefault();

            this.close();
          });
        }

        this.saveButton = this.querySelector('.save-custom-size');
        if (this.saveButton) {
          this.saveButton.addEventListener('click', (e) => {
            e.preventDefault();

            this.save();
          });
        }

        this.form = this.querySelector('form');
        if (this.form) {
          this.form.addEventListener('submit', (e) => {
            e.preventDefault();

            this.save();
          });
        }

        this.addEventListener('input', (e) => {
          for (let target = e.target; target && target != this; target = target.parentNode) {
            if (target.matches('.input-custom-size')) {
              this.validateForm();

              break;
            }
          }
        });

        this.allInputs = this.form.querySelectorAll('input');
        this.lengthInput = this.querySelector('[data-type="length"] input');
        this.widthInput = this.querySelector('[data-type="width"] input');
        this.heightInput = this.querySelector('[data-type="height"] input');
      }

      set isValid(value) {
        this.saveButton.classList.remove('button-disable');
        if (!value) this.saveButton.classList.add('button-disable');

        this._isValid = value;
      }

      get isValid() {
        return this._isValid;
      }

      open() {
        this.sizeDropdown = document.querySelector('size-dropdown');
        if (this.sizeDropdown) {
          this.selectedSizeText = this.sizeDropdown.querySelector('.selected-text');
          this.selectedSizeOpenText = this.sizeDropdown.querySelector('.selected-open-text');
        }

        this.isValid = false;
        this.style.display = 'block';
      }

      close() {
        this.style.display = 'none';

        this.form.reset();

        this.allInputs.forEach((input) => {
          input.value = '';
          input.classList.remove('ng-invalid');
        });
      }

      save() {
        if (!this.customSize) return;

        const {length, width, height} = this.customSize;

        const sizeHtml = `<b> ${length} </b> x <b> ${width} </b> x <b> ${height} </b>`;

        if (this.selectedSizeText) {
          this.selectedSizeText.innerHTML = sizeHtml;
        }

        if (this.selectedSizeOpenText) {
          this.selectedSizeOpenText.innerHTML = sizeHtml;
        }

        if (this.sizeDropdown) {
          this.sizeDropdown.dataset.value = 'custom';
          this.sizeDropdown.dataset.customValue = `${length}x${width}x${height}`;
          this.sizeDropdown.dispatchEvent(new Event('change', {bubbles: true}));
        }

        this.close();
      }

      validateForm() {
        let tempSize = {
          length: null,
          width: null,
          height: null,
        };

        // Check if all inputs are valid
        const isValidInputs = Array.from(this.allInputs).map((input) => {
          let isValid = false;

          // Get input type
          const type = String(input.closest('.input-box').dataset.type);

          // Trim input value
          input.value = input.value.trim();

          // Check if input is empty
          if (input.value != '') {
            // Remove all non numeric characters
            input.value = input.value.replace(/[^\d+(\.\d+)?)$]/g, '');

            // Check if input is a valid number
            if (/^(\d+(\.\d+)?)$/.test(input.value)) {
              isValid = true;
              tempSize[type] = parseFloat(input.value);
            }
          }

          // Add or remove invalid class
          if (isValid) input.classList.remove('ng-invalid');
          else input.classList.add('ng-invalid');

          // Return if input is valid
          return isValid;
        });

        if (!isValidInputs.every((isValid) => isValid)) {
          this.isValid = false;
          return;
        }

        const {length, width, height} = tempSize;

        // Check if dimensions are valid
        if (length != null && width != null && height != null) {
          let errorMessage = '';

          if (this.boxType == 'mailer' && !this.checkDimensions(tempSize, this.mailerMaxSizes)) {
            errorMessage = `max size of W=${this.mailerMaxSizes.width} L=${this.mailerMaxSizes.length} D=${this.mailerMaxSizes.height}`;
          } else if (this.boxType == 'mailer' && !this.checkDimensions(tempSize, this.mailerMinSizes, 'min')) {
            errorMessage = `min size of W=${this.mailerMinSizes.width} L=${this.mailerMinSizes.length} D=${this.mailerMinSizes.height}`;
          } else if (this.boxType == 'shipper' && !this.checkDimensions(tempSize, this.shipperMinSizes, 'min')) {
            errorMessage = `min size of W=${this.shipperMinSizes.width} L=${this.shipperMinSizes.length} D=${this.shipperMinSizes.height}`;
          } else if (this.boxType == 'shipper' && !this.checkDimensions(tempSize, this.shipperMaxSizes)) {
            errorMessage = `max size of W=${this.shipperMaxSizes.width} L=${this.shipperMaxSizes.length} D=${this.shipperMaxSizes.height}`;
          } else if (
            this.boxType == 'shipper' &&
            !this.bothDimensions(tempSize, this.bothCompare, this.maxBothCompare)
          ) {
            errorMessage = `Length and Width combined cannot exceed 48 inches`;
          } else if (this.boxType == 'mailer' && (height > length || height > width)) {
            this.heightInput.classList.add('ng-invalid');
            errorMessage = 'Box Height cannot be greater than the Length or the Width';
          }

          this.isValid = errorMessage === '';
          this.errorContainer.textContent = errorMessage;
          if (this.isValid) this.errorContainer.classList.add('hidden');
          else this.errorContainer.classList.remove('hidden');
        }

        if (!this.isValid) return;

        this.customSize = tempSize;
      }

      bothDimensions(customSize, dimensions, limit) {
        let isValidSize = true;
        let sum = 0;
        for (const key in customSize) {
          if (dimensions.includes(key)) {
            sum += customSize[key];
          }
        }
        if (sum > limit) {
          isValidSize = false;
          for (const key in customSize) {
            const inputKey = `${key}Input`;
            this[inputKey].classList.add('ng-invalid');
          }
        }
        return isValidSize;
      }

      checkDimensions(customSize, limitSizes, mode = 'max') {
        let isValidSize = true;

        for (const key in customSize) {
          const inputKey = `${key}Input`;
          let isValidDimension = false;

          if (mode == 'max') isValidDimension = customSize[key] <= limitSizes[key];
          else isValidDimension = customSize[key] >= limitSizes[key];

          if (isValidDimension) this[inputKey].classList.remove('ng-invalid');
          else {
            isValidSize = false;
            this[inputKey].classList.add('ng-invalid');
          }
        }

        return isValidSize;
      }
    },
  );
}
